module.exports = __webpack_public_path__ + "assets/images/5e8941d1aba53d99ca5f5cede7e61cf8.png";